// src/utils/navigationMemory.js

const PRODUCT_RETURN_KEY = "etika-product-return-position";
const LISTING_STATE_PREFIX = "etika-listing-state:";

export const getCurrentPageKey = () => {
  return `${window.location.pathname}${window.location.search}`;
};

export const saveProductReturnPosition = ({ productId, element }) => {
  if (typeof window === "undefined") return;

  const rect = element?.getBoundingClientRect?.();

  const payload = {
    sourceKey: getCurrentPageKey(),
    productId: productId ? String(productId) : "",
    scrollY: window.scrollY || 0,
    rectTop: rect ? rect.top : null,
    createdAt: Date.now(),
  };

  sessionStorage.setItem(PRODUCT_RETURN_KEY, JSON.stringify(payload));
};

export const restoreProductReturnPosition = ({ maxTries = 80, delay = 40 } = {}) => {
  if (typeof window === "undefined") return;

  let saved = null;

  try {
    saved = JSON.parse(sessionStorage.getItem(PRODUCT_RETURN_KEY) || "null");
  } catch {
    saved = null;
  }

  if (!saved?.sourceKey) return;

  const currentKey = getCurrentPageKey();

  if (saved.sourceKey !== currentKey) return;

  // ✅ Generic page return, used by SaleBanner / CategoryCarousel / buttons
// where there is no specific product card to target.
if (!saved.productId) {
  window.scrollTo({
    top: Math.max(0, Number(saved.scrollY || 0)),
    left: 0,
    behavior: "instant",
  });

  sessionStorage.removeItem(PRODUCT_RETURN_KEY);
  return;
}

  const isExpired = Date.now() - Number(saved.createdAt || 0) > 1000 * 60 * 30;

  if (isExpired) {
    sessionStorage.removeItem(PRODUCT_RETURN_KEY);
    return;
  }

  let tries = 0;

  const run = () => {
    tries += 1;

    const selector = saved.productId
      ? `[data-product-card-id="${CSS.escape(String(saved.productId))}"]`
      : "";

    const element = selector ? document.querySelector(selector) : null;

    if (element) {
      const rect = element.getBoundingClientRect();

      const targetY =
        saved.rectTop !== null && saved.rectTop !== undefined
          ? window.scrollY + rect.top - Number(saved.rectTop)
          : Number(saved.scrollY || 0);

      window.scrollTo({
        top: Math.max(0, targetY),
        left: 0,
        behavior: "instant",
      });

      sessionStorage.removeItem(PRODUCT_RETURN_KEY);
      return;
    }

    if (tries >= maxTries) {
      window.scrollTo({
        top: Math.max(0, Number(saved.scrollY || 0)),
        left: 0,
        behavior: "instant",
      });

      sessionStorage.removeItem(PRODUCT_RETURN_KEY);
      return;
    }

    window.setTimeout(run, delay);
  };

  window.requestAnimationFrame(run);
};

export const saveListingState = (state) => {
  if (typeof window === "undefined") return;

  const key = `${LISTING_STATE_PREFIX}${getCurrentPageKey()}`;

  sessionStorage.setItem(
    key,
    JSON.stringify({
      ...state,
      createdAt: Date.now(),
    })
  );
};

export const getListingState = () => {
  if (typeof window === "undefined") return null;

  const key = `${LISTING_STATE_PREFIX}${getCurrentPageKey()}`;

  try {
    const saved = JSON.parse(sessionStorage.getItem(key) || "null");

    if (!saved) return null;

    const isExpired = Date.now() - Number(saved.createdAt || 0) > 1000 * 60 * 30;

    if (isExpired) {
      sessionStorage.removeItem(key);
      return null;
    }

    return saved;
  } catch {
    return null;
  }
};